var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-xs-right"},[_c('router-link',{attrs:{"to":{ name: _vm.route, params: { id: _vm.id }}}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }